"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConsumes = exports.getProduces = exports.getSecurities = void 0;
const lodash_1 = require("lodash");
const fp_1 = require("lodash/fp");
const guards_1 = require("./guards");
function getSecurities(spec, operationSecurity) {
    const globalSecurities = getSecurity(spec.security, spec.securityDefinitions || {});
    const operationSecurities = getSecurity(operationSecurity, spec.securityDefinitions || {});
    const securities = !!operationSecurity ? operationSecurities : globalSecurities;
    return securities.filter(fp_1.negate(lodash_1.isEmpty));
}
exports.getSecurities = getSecurities;
function getProduces(spec, operation) {
    return getProducesOrConsumes('produces', spec, operation);
}
exports.getProduces = getProduces;
function getConsumes(spec, operation) {
    return getProducesOrConsumes('consumes', spec, operation);
}
exports.getConsumes = getConsumes;
function getSecurity(security, definitions) {
    if (!security || !definitions) {
        return [];
    }
    return lodash_1.map(security, sec => {
        return lodash_1.compact(lodash_1.keys(sec).map(key => {
            const def = definitions[key];
            if (guards_1.isSecurityScheme(def)) {
                const defCopy = lodash_1.merge({ key }, def);
                const scopes = sec[key] || [];
                if (defCopy.type === 'oauth2' && scopes.length) {
                    defCopy.scopes = lodash_1.pickBy(defCopy.scopes, (_val, s) => scopes.includes(s));
                }
                return defCopy;
            }
            return null;
        }));
    });
}
function getProducesOrConsumes(which, spec, operation) {
    const mimeTypes = lodash_1.get(operation, which, lodash_1.get(spec, which, []));
    if (!Array.isArray(mimeTypes)) {
        return [];
    }
    return lodash_1.compact(mimeTypes).filter(v => v && lodash_1.isString(v));
}
//# sourceMappingURL=accessors.js.map